import { findSellingEstatesData } from '@/api/selling.api';
import { pushToQuery, trimNilOrEmptyParameters, withLoading } from '@/shared';
import { CCSRouteMap } from '@condo/domain';
import type { ISellingEstate, ISellingEstatesDataQuery } from '@condo/domain';
import { useQuery } from '@tanstack/vue-query';
import type { Ref } from 'vue';
import { computed, unref } from 'vue';

export const useSellingEstatesData = (filter: Ref<ISellingEstatesDataQuery>) => {
    const queryFilter = computed(() => unref(filter));
    const queryEnabled = computed(() => Object.keys(queryFilter.value).length > 0);

    return useQuery(
        ['selling/data', queryFilter],
        async (): Promise<{ estates: ISellingEstate[]; total: number }> => {
            pushToQuery(CCSRouteMap['selling.estates-data'].name, queryFilter.value);
            return withLoading(async () => findSellingEstatesData(trimNilOrEmptyParameters(queryFilter.value)));
        },
        { initialData: { estates: [], total: 0 }, enabled: queryEnabled },
    );
};
